import React, { FC, useCallback, useContext, useMemo } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';

const RoamingPass: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v7/${path}`), []);
  const store = useContext(NolPromotionStoreCtx);

  const nolCouponCardProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>이벤트 4</div>,
      title: (
        <div className={styles.cardTitle}>
          NOL 카드 회원은
          <br />
          <span className={styles.blue}>로밍패스2 1년 가입비 0원</span>
          <br />
          혹은 <span className={styles.blue}>로밍 첫 구매 할인</span>
          <div className={styles.subTitle}>
            ※ 로밍패스2는 핀다이렉트에서 제공하는 서비스로
            <br />
            제휴사 사정에 따라 변경될 수 있으니
            <br />
            핀다이렉트(pindirectshop.com)등을 통해 확인
          </div>
        </div>
      ),
      image: (
        <img
          className={styles.nolCouponImage}
          src={getResourcePath('roaming_pass_step_card.png')}
          alt={'로밍패스2 1년 가입비 0원'}
        />
      ),
      description: {
        bold: ['로밍패스2 1년 가입비 0원 혹은 첫 구매 최대 1만원 할인\n'].join(''),
      },
      descriptions: [
        { text: `이벤트 기간 : ${store.eventPeriod}` },
        { text: '대상 : NOL 카드 보유 회원' },
        { text: '로밍패스2 1년 가입비 NOL 카드로 결제 시 즉시 할인\n(1년 가입비 4,900원 -> 0원)' },
        { text: '로밍패스2란 1년간 전 세계 로밍을 무제한 20% 할인 받는 로밍 할인 구독권입니다.' },
        { text: '로밍패스2 20% 할인 혜택과 NOL 카드 회원의 혜택인 로밍 첫 구매 시 최대 1만원 할인은 동시 적용 불가' },
        { text: '본 이벤트를 통해 가입 후 최초 결제 건에 한해 최대 1만원 할인혜택이 제공됩니다. (1회 한정)' },
        { text: '신청 페이지에서 NOL 카드 인증 후 이용 가능' },
        { text: '상세 내용은 혜택 받기 페이지에서 확인' },
      ],
      link: {
        onLinkClick: () => (location.href = 'https://pindirectshop.kr/3IyVJiH'),
        onLinkTitle: '로밍패스2 혜택 받기',
      },
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.nolCouponCardContainer}
      {...nolCouponCardProps}
      logData={{
        object: '로밍패스2 혜택 받기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
        motherPageVersion: store.version,
        motherPageSectionType: '혜택',
        motherPageSectionName: '로밍패스2 1년 가입비 0원 혹은 로밍 첫구매 할인',
        deepLinkUri: 'https://pindirectshop.kr/3IyVJiH',
      }}
    />
  );
};

export default observer(RoamingPass);
